{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/post-time-to-read",
	"title": "Time to Read",
	"category": "theme",
	"description": "Show minutes required to finish reading the post. Can also show a word count.",
	"textdomain": "default",
	"usesContext": [ "postId", "postType" ],
	"attributes": {
		"displayAsRange": {
			"type": "boolean",
			"default": true
		},
		"displayMode": {
			"type": "string",
			"default": "time"
		},
		"averageReadingSpeed": {
			"type": "number",
			"default": 189
		}
	},
	"supports": {
		"anchor": true,
		"color": {
			"gradients": true,
			"__experimentalDefaultControls": {
				"background": true,
				"text": true
			}
		},
		"html": false,
		"spacing": {
			"margin": true,
			"padding": true,
			"__experimentalDefaultControls": {
				"margin": false,
				"padding": false
			}
		},
		"typography": {
			"fontSize": true,
			"lineHeight": true,
			"textAlign": true,
			"__experimentalFontFamily": true,
			"__experimentalFontWeight": true,
			"__experimentalFontStyle": true,
			"__experimentalTextTransform": true,
			"__experimentalTextDecoration": true,
			"__experimentalLetterSpacing": true,
			"__experimentalDefaultControls": {
				"fontSize": true
			}
		},
		"interactivity": {
			"clientNavigation": true
		},
		"__experimentalBorder": {
			"radius": true,
			"color": true,
			"width": true,
			"style": true
		}
	}
}
